// extracted by mini-css-extract-plugin
export var typingIndicator = "_ix-0";